// src/components/common/PageBanner.jsx
import React, { useEffect } from "react";

/** Single-line string for <title>; matches visible banner text without line breaks. */
const normalizeTitleForDocument = (raw) => {
  if (raw == null || raw === "") return null;
  const s = String(raw)
    .replace(/\\n/g, " ")
    .replace(/\n/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return s || null;
};

const PageBanner = ({
  title,
  imageUrl,
  titleColorIsWhite = true,
  placeholderImageUrl = "/placeholder-banner.jpg",
  bannerHeightClass = "h-56 sm:h-64 md:h-72 lg:h-80",
}) => {
  const finalImageUrl = imageUrl ? `${imageUrl}` : placeholderImageUrl;

  const titleTextColorClass = titleColorIsWhite
    ? "text-white drop-shadow-md"
    : "text-gray-900 drop-shadow-md";

  const overlayClass = titleColorIsWhite ? "bg-black/55" : "bg-black/45";

  const updatedTitle = title ? title.replace("\\n", "\n") : null;

  useEffect(() => {
    const docTitle = normalizeTitleForDocument(title);
    if (docTitle) {
      document.title = docTitle;
    }
  }, [title]);

  return (
    <div
      className={`relative bg-cover bg-center ${bannerHeightClass}`}
      style={{ backgroundImage: `url(${finalImageUrl})` }}
      role="banner"
    >
      <div className={`absolute inset-0 ${overlayClass}`}></div>
      {updatedTitle && (
        <div className="absolute inset-0 z-10 flex items-center justify-end pr-8 sm:pr-12 md:pr-16 lg:pr-24">
          <div className="w-2/3 sm:w-1.5/2 lg:w-1/2 text-right">
            <div className="inline-block mt-[15%] md:mt-[10%] whitespace-pre-line">
              <h1
                className={`text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold ${titleTextColorClass}"`}
              >
                {" "}
                {updatedTitle}
              </h1>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageBanner;
